import { Box, Typography } from "@mui/joy";
import { motion } from "framer-motion";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";

/** Бейдж «% совпадения» для карточки ленты. props: value (number|null), onClick */
export default function CompatibilityBadge({ value, onClick }) {
  if (value == null) return null;
  const color = value >= 75 ? "#1F7A1F" : value >= 50 ? "#7c3aed" : "#8b5e00";
  return (
    <Box
      component={motion.button}
      type="button"
      initial={{ scale: 0.6, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: "spring", stiffness: 300, damping: 18 }}
      whileTap={{ scale: 0.94 }}
      onClick={onClick}
      sx={{
        cursor: "pointer",
        border: "none",
        font: "inherit",
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        px: 1,
        py: 0.5,
        borderRadius: "999px",
        backgroundColor: "rgba(255,255,255,0.92)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
      }}
    >
      <FavoriteRoundedIcon sx={{ fontSize: 16, color }} />
      <Typography sx={{ fontWeight: 800, fontSize: 14, color }}>{value}%</Typography>
    </Box>
  );
}